<template>
  <HeaderTitle :back-target-func="changeView">
    <template #top>{{ t("code.scan.screen.title") }}</template>
    <template #bottom>{{ t("code.web.subtitle") }}</template>
  </HeaderTitle>

  <h2 class="text-large">{{ t("code.scan.screen.web") }}</h2>
  <div
    class="w-full sm:w-96 h-96 flex flex-col justify-center items-center mx-auto"
  >
    <div class="pt-8 w-full">
      <InputElement
        id="auth_code"
        v-model="authCode"
        :label="t('code.scan.input.hint')"
        max-length="12"
        :required="true"
        :placeholder="t('registration.e.mail.input.hint')"
      />
    </div>
    <div v-if="error">{{ error }}</div>
  </div>

  <div class="flex flex-col justify-center items-center mt-4 gap-4">
    <BaseButton
      variant="primary"
      :disabled="!authCode"
      @click="handleFetchClick"
      >Weiter</BaseButton
    >
  </div>
</template>

<script setup lang="ts">
import InputElement from "../form/InputElement.vue";
import BaseButton from "../layout/button/BaseButton.vue";
import { ref } from "vue";
import { useRoute } from "vue-router";
import { useClientStore } from "../../../store/v2/client.js";
import HeaderTitle from "../layout/header/HeaderTitle.vue";
import { useI18n } from "vue-i18n";
const { appContext } = getCurrentInstance()!;

const { t } = useI18n();
const authCode = ref("");
const error = ref("");
const route = useRoute();
const clientStore = useClientStore();
const userAuthenticator = appContext.config.globalProperties.$userAuthenticator;

onMounted(() => {
  userAuthenticator.resetStores();
});

async function handleFetchClick() {
  try {
    await clientStore
      .getClient(authCode.value, route.params.slug, true)
      .then(() => {
        window.history.pushState(null, "", `/${clientStore.slug}/login`);
        error.value = "";
        emit("close");
        emit("change-view", "accept");
      });
  } catch (err: any) {
    error.value = "Der eingegebene Code ist ungültig.";
    console.error(err?.response?.data?.message ?? "Failed to fetch client");
  }
}
defineProps({
  open: Boolean,
});

const emit = defineEmits(["change-view", "close"]);

function changeView(view: string) {
  if (clientStore.slug !== null) {
    window.history.pushState(null, "", `/${clientStore.slug}/login`);
  } else {
    window.history.pushState(null, "", `/login`);
  }

  emit("change-view", "start");
}
</script>
